import { useGet } from '../../../sharedModules/hooks/useQuery';

const EMAIL_ISSUES_COUNT_URL = '/vendors/outlook_emails/issues_count';

export function useEmailIssuesCount() {
  return useGet<{ count: number }>({
    url: EMAIL_ISSUES_COUNT_URL,
  });
}
